import { Injectable } from '@angular/core';
import { ConfigService } from 'src/app/core/services/config.service';
@Injectable()
export class ImpersonateCarrierService {

  constructor(private config: ConfigService) {}

  public async carrierChanged() {
    const config = await this.config.getConfig();
    const baseUrl = `https://hubconnect${config.runtime.envName}.hubgroup.com`;
    setTimeout(() => {
      window.location.href = `${baseUrl}/carriers`;
    }, 1200);
  }

}

